import { b64toBlob, b64toUint8Array } from "./Requests"
import {
  createCustomMultipartRequestBody,
  customBoundary,
} from "../multipart/CustomMultipartRequestHelper"
import { MultipartAssetUpload } from "../multipart/MultipartAssetUpload"
import { AspectRatio } from "../../utils/AspectRatioUtil"

export async function removeBackground(presetCode: string, imageData: string): Promise<string> {
  const formData = new FormData()
  formData.append("image", b64toBlob(imageData), "image.jpg")

  const response = await fetch(
    process.env.REACT_APP_API_BASE_URL +
      "api/presets/by-code/" +
      presetCode +
      "/preview/background-removal",
    {
      method: "POST",
      body: formData,
    },
  )

  if (!response.ok) {
    throw new Error(`${response.status} error`)
  }

  const json = await response.json()
  return json.imageUrl
}

export async function processAiEffect(
  presetCode: string,
  imageData: string,
  guestInputValues: Record<string, string>,
  aspectRatio: AspectRatio = "1:1",
): Promise<string> {
  const asset: MultipartAssetUpload = {
    key: "image",
    filename: "image.jpg",
    mimeType: "image/jpeg",
    data: b64toUint8Array(imageData),
  }
  const json = JSON.stringify(
    {
      guestInputValues: guestInputValues,
      aspectRatio: aspectRatio,
    }
  )
  const body = createCustomMultipartRequestBody(json, [asset])

  const response = await fetch(
    process.env.REACT_APP_API_BASE_URL +
      "api/presets/by-code/" +
      presetCode +
      "/preview/ai-effect-processing",
    {
      method: "POST",
      headers: {
        "Content-Type": `multipart/mixed; charset=utf-8; boundary=${customBoundary}`,
      },
      body: body,
    },
  )

  if (!response.ok) {
    throw new Error(`${response.status} error`)
  }

  const blob = await response.blob()
  const mimeType = response.headers.get("content-type") ?? "image/png"
  return await blobToDataUrl(blob, mimeType)
}

function blobToDataUrl(blob: Blob, mimeType: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result as string)
    reader.onerror = reject
    reader.readAsDataURL(new Blob([blob], { type: mimeType }))
  })
}
